// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../hooks/useQuoteContext'
// Component Imports
import HorizontalRule from '../ui-helper-elements/HorizontalRule'
import MonthlyDiscountsHeaderRow from '../rows/monthly-discounts/MonthlyDiscountsHeaderRow'
import BundleDiscountRow from '../rows/monthly-discounts/BundleDiscountRow'
import NonProfitDiscountRow from '../rows/monthly-discounts/NonProfitDiscountRow'
import PrepaymentDifferenceRow from '../rows/monthly-discounts/PrepaymentDifferenceRow'
import MultiEntityDiscountRow from '../rows/monthly-discounts/MultiEntityDiscountRow'
import BooleanDiscount from '../ui-helper-elements/BooleanDiscount'
import NumberDiscount from '../ui-helper-elements/NumberDiscount'
import { DiscountFamilyDropdown } from '../ui-helper-elements/DiscountFamilyDropdown'
import DealDeskActive from '../ui-helper-elements/DealDeskActive'
// JS Imports
// Asset Imports

export default function MonthlyDiscountsSection() {
   const state = useQuoteContext()

   // Collect discount families and individual discounts
   let discount_families = new Set()
   let individual_discount_keys = []

   for (let discount in state.discount_list) {
      if (
         state.discount_list[discount]['Promotional'] &&
         state.discount_list[discount]['BillingFreq'] == 'monthly'
      ) {
         // If discount has a DiscountFamily, add to families set
         if (state.discount_list[discount]['DiscountFamily']) {
            discount_families.add(
               state.discount_list[discount]['DiscountFamily'],
            )
         } else {
            // If no DiscountFamily, add to individual discounts
            individual_discount_keys.push(
               state.discount_list[discount]['DiscountCode'],
            )
         }
      }
   }

   // Create DiscountFamilyDropdown components for each family
   let family_dropdowns = Array.from(discount_families).map((family, key) => {
      // Find the lowest DisplayOrder among discounts in this family for ordering
      let familyOrder = 999
      for (let discount in state.discount_list) {
         if (state.discount_list[discount]['DiscountFamily'] === family) {
            familyOrder = Math.min(
               familyOrder,
               state.discount_list[discount]['DisplayOrder'] || 999,
            )
         }
      }

      return (
         <DiscountFamilyDropdown
            key={`family-${key}`}
            discountFamily={family}
            order={familyOrder}
         />
      )
   })

   // Create individual discount components (excluding those with DiscountFamily)
   let monthly_discounts = individual_discount_keys.map((discountCode, key) => {
      if (state.discount_list[discountCode]['InputType'] == 'Number')
         return (
            <NumberDiscount
               key={key}
               discount_key={discountCode}
               order={state.discount_list[discountCode]['DisplayOrder']}
            />
         )
      else
         return (
            <BooleanDiscount
               key={key}
               discount_key={discountCode}
               order={state.discount_list[discountCode]['DisplayOrder']}
            />
         )
   })

   return (
      <div className='monthlyDiscounts'>
         {state.user_view == 'Internal' ? (
            <HorizontalRule></HorizontalRule>
         ) : (
            ''
         )}
         <MonthlyDiscountsHeaderRow />
         <DealDeskActive order={-50} billingFreq='monthly' />
         <BundleDiscountRow
            order={state.discount_list['bundleDiscount']['DisplayOrder']}
         />
         <NonProfitDiscountRow
            order={state.discount_list['nonProfit']['DisplayOrder']}
         />
         {/* AnnualPrepaymentDiscountRow removed - prepayment discounts now handled via DiscountFamilyDropdown */}
         <PrepaymentDifferenceRow
            order={
               Math.min(
                  ...Object.values(state.discount_list)
                     .filter((d) => d.DiscountFamily === 'Prepayment Discount')
                     .map((d) => d.DisplayOrder)
                     .filter((order) => order != null),
                  999,
               ) + 1
            }
         />
         <MultiEntityDiscountRow
            order={state.discount_list['relatedEntity']['DisplayOrder']}
         />
         {/* <MonthlyPromotionDiscountRow></MonthlyPromotionDiscountRow> */}
         {/* <HRDealDeskMonthlyDiscountRow></HRDealDeskMonthlyDiscountRow> */}
         {monthly_discounts}
         {family_dropdowns}
      </div>
   )
}
